import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "100%" : '55%'
  },
};

export default function EditProbondho({
    editProbondhoInfo,
    setEdit,
    edit,
}) {
    const [probondhoEditInfo, setProbondhoEditInfo] = useState({});

    useEffect(() => setProbondhoEditInfo(editProbondhoInfo), []);

    const probondhoEdit = async (e) => {
        e.preventDefault();
        try {
            const probondhoInserted = await axios.put(
              `https://ahlehaqserver.herokuapp.com/api/probondho/${editProbondhoInfo._id}`,
              probondhoEditInfo
            );
    
            //if request success, will show success notification
            if (probondhoInserted.data.code === 200) {
                
              setEdit(false)
              toast.success("Probondho edited successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };

      console.log(probondhoEditInfo)
    return (
        <>
         <Modal isOpen={edit} style={customStyles}>

             <form onSubmit={probondhoEdit}>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Probondho Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="write probondho title"
                              id="exampleInputPassword1"
                              name="title"
                              value={probondhoEditInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setProbondhoEditInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Probondho Short Description<span className="text-danger">*</span>
                            </label>
                            <textarea
                              type="text"
                              rows="3"
                              className="form-control"
                              placeholder="write probondho short description"
                              id="exampleInputPassword1"
                              name="shortDetails"
                              value={probondhoEditInfo?.shortDetails || ""}
                              required
                              onChange={(e) =>
                                setProbondhoEditInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>
                          
                         <div className="col-md-12">
                         <label for="exampleInputEmail1" className="font-weight-bold">
                                Write Description<span className="text-danger">*</span>
                              </label>
                            <CKEditor
                                editor={ ClassicEditor }
                                data={probondhoEditInfo?.description || ""}
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setProbondhoEditInfo((Prev) => ({ ...Prev, description: data }))
                           
                                } }
                            />
                         </div>  
                          
                         <div className="col-md-6">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                              <button
                                className="btn btn-danger rounded-pill px-4 ml-3"
                                onClick={() => setEdit(false)}
                                >
                                Close
                                </button>
                            </div>  
                         </div> 

                      </div>

                      
                    </form>
         
         </Modal>   
        </>
    )
}
